module.exports = __webpack_public_path__ + "assets/img/picture1.c2715979.jpg";